import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface ISaveTimeRoundingSettings {
  round_clock_in: boolean;
  round_clock_out: boolean;
  clock_in: {
    rounding_direction: string;
    rounding_increment: number;
  };
  clock_out: {
    rounding_direction: string;
    rounding_increment: number;
  };
}

const saveTimeRoundingSettings = (postData: ISaveTimeRoundingSettings) => {
  return http().post(endpoints.companySettings.timeRoundingSettings, postData);
};

export function useSaveTimeRoundingSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveTimeRoundingSettings,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
